import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";

function Catagory(props) {
  const { token } = isAutheticated();
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);

  const [success, setSuccess] = useState(true);
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [showData, setShowData] = useState(data);
  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      try {
        let res = await axios.get(`${API}/api/category`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdata(res.data?.categories);
      } catch (error) {
        console.error("Error fetching featured products:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData()
  }, [success]);
  //pagination
  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(data.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [data, currentPage, itemPerPage]);
  const handleDelete = async (id) => {
    swal({
      title: "Are you sure?",
      buttons: [
        {
          value: "cancel",
          text: "Cancel",
        },
        {
          value: "delete",
          text: "Delete",
        },
      ],
    }).then((value) => {
      if (value === "delete") {
        axios
          .delete(`${API}/api/category/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setSuccess((prev) => !prev);
          })
          .catch((e) => {
            setSuccess((prev) => !prev);
          });
      }
    });
  };
  console.log(data);
  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          {/* <!-- start page title --> */}

          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>OTT Shop - Categories</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/dashboard'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>OTT Shop - Categories</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- end page title --> */}

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row ml-0 mr-0  mb-10'>
                    <div className='col-sm-12 col-md-6'>&nbsp;</div>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dropdown d-block'>
                        {/* <Link to="/comcatagory/add">
                          <button
                            type="button"
                            className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                          >
                            <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                           
                          </button>
                        </Link> */}
                        <Link to={`/comcatagory/add`}>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm  waves-effect waves-light btn-table ml-2'>
                            Add New
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='table-responsive table-shoot'>
                    <table className='table table-centered table-nowrap mb-0'>
                      <thead className='thead-light'>
                        <tr>
                          <th>Category Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : showData?.length > 0 ?
                          (showData?.map((item) => (
                            <tr key={item._id}>
                              <td>{item.category}</td>
                              <td>
                                <Link to={`/comcatagory/edit/${item._id}`}>
                                  <button
                                    type='button'
                                    className='btn btn-primary btn-sm  waves-effect waves-light btn-table ml-2'>
                                    Edit
                                  </button>
                                </Link>

                                <button
                                  onClick={() => handleDelete(item._id)}
                                  type='button'
                                  className='btn btn-danger btn-sm  waves-effect waves-light btn-table ml-2'
                                  id='sa-params'>
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))) : (
                            <tr>
                              <td colSpan="10" align="center" style={{ padding: "20px" }}>
                                <div style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                                  No Channel Found. Please add New Channel to display here.
                                </div>
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>

                  {/* <!-- end table-responsive --> */}
                  {/* Pagination */}
                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, data?.length)} of{" "}
                        {data?.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            data?.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                data?.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- container-fluid --> */}
      </div>
      {/* <!-- End Page-content --> */}

      {/* <footer className="footer">
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<script>document.write(new Date().getFullYear())</script> © SoComOTT
						</div>

					</div>
				</div>
			</footer> */}
      <Footer />
    </div>
  );
}

export default Catagory;
